import { render, staticRenderFns } from "./kdform.vue?vue&type=template&id=385b4260&scoped=true&"
import script from "./kdform.vue?vue&type=script&lang=js&"
export * from "./kdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b4260",
  null
  
)

export default component.exports